import { useCallback, useMemo } from 'react';
import Checkbox from '../../general-ui/checkbox/checkbox';
import { useDispatch, useSelector } from 'react-redux';
import {
	addSelectedMember,
	removeSelectedMember,
} from '../../../store/actions/admin/passcode-list-members';
import { EventsState } from '../../../store/types';
import { ICONS } from '../../general-ui/icon';

export interface MemberProps {
	member: any;
	type: number;
}

export default function PasscodeListMember(props: MemberProps): JSX.Element {
	const {
		PasscodeListMembersReducer: { selectedMembers },
	} = useSelector((state: EventsState) => state);

	const { member, type } = props;

	const dispatch = useDispatch();
	const isSelected = useCallback(
		(id: string) => {
			let check = false;
			if (selectedMembers) {
				selectedMembers.forEach((member: any) => {
					if (member.passcode_list_member === id) {
						check = true;
					}
				});
				return check;
			}
			return check;
		},
		[selectedMembers]
	);
	const handleCheckbox = useCallback(() => {
		if (isSelected(member.passcode_list_member)) {
			dispatch(removeSelectedMember(member));
		} else {
			dispatch(addSelectedMember(member));
		}
	}, [dispatch, isSelected, member]);

	const formattedMember = useMemo(() => {
		switch (type) {
			case 0: {
				if (member.email) {
					return (
						<li className="list-item">
							<div>
								<Checkbox
									size={16}
									checked={isSelected(
										member.passcode_list_member
									)}
									value={member.passcode_list_member}
									onChange={handleCheckbox}
									selectedIconName={
										ICONS.SQUARE_CHECKBOX_SELECTED
									}
									unselectedIconName={
										ICONS.SQUARE_CHECKBOX_UNSELECTED
									}
									transparent
								/>
							</div>
							<div>{member.email}</div>
						</li>
					);
				} else {return;}
			}
			case 1: {
				if (member.passcode) {
					return (
						<li className="list-item">
							<div>
								<Checkbox
									size={16}
									checked={isSelected(
										member.passcode_list_member
									)}
									value={member.passcode_list_member}
									onChange={handleCheckbox}
									selectedIconName={
										ICONS.SQUARE_CHECKBOX_SELECTED
									}
									unselectedIconName={
										ICONS.SQUARE_CHECKBOX_UNSELECTED
									}
									transparent
								/>
							</div>
							<div>{member.passcode}</div>
						</li>
					);
				} else {return;}
			}
			case 2: {
				return (
					<li className="list-item">
						<div>
							<Checkbox
								size={16}
								checked={isSelected(
									member.passcode_list_member
								)}
								value={member.passcode_list_member}
								onChange={handleCheckbox}
								selectedIconName={
									ICONS.SQUARE_CHECKBOX_SELECTED
								}
								unselectedIconName={
									ICONS.SQUARE_CHECKBOX_UNSELECTED
								}
								transparent
							/>
						</div>
						<div>
							{member.passcode ? (
								member.passcode
							) : (
								<span className="inactive">Not setup</span>
							)}
						</div>
						<div>
							{member.email ? (
								member.email
							) : (
								<span className="inactive">Not setup</span>
							)}
						</div>
					</li>
				);
			}
			default: {
				return (
					<li className="list-item">
						<div>
							<Checkbox
								size={16}
								checked={isSelected(
									member.passcode_list_member
								)}
								value={member.passcode_list_member}
								onChange={handleCheckbox}
								selectedIconName={
									ICONS.SQUARE_CHECKBOX_SELECTED
								}
								unselectedIconName={
									ICONS.SQUARE_CHECKBOX_UNSELECTED
								}
								transparent
							/>
						</div>
						<div>{member.passcode}</div>
						<div>{member.email}</div>
						<div>
							{member.uses === 0 ? (
								<span className="inactive">Not Used</span>
							) : (
								<span>Used</span>
							)}
							{member.uses === 1 || member.uses === 0
								? ``
								: ` (${member.uses})`}
						</div>
					</li>
				);
			}
		}
	}, [
		handleCheckbox,
		isSelected,
		member.email,
		member.passcode,
		member.passcode_list_member,
		member.uses,
		type,
	]);

	return <>{formattedMember}</>;
}
